import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import zhCN from './locales/zh-CN.json';
import enUS from './locales/en-US.json';
import pagesZhCN from './locales/pages-zh-CN.json';
import pagesEnUS from './locales/pages-en-US.json';

// 将 WGI 译文中的公司名替换为 SSG
const replaceToSSG = (obj) => {
  const jsonStr = JSON.stringify(obj);
  const replacedStr = jsonStr
    .replace(/Wawasan Global Institute \(WGI\)/g, 'Straits Strategy Group (SSG)')
    .replace(/Wawasan Global Institute/g, 'Straits Strategy Group')
    .replace(/WGI/g, 'SSG');
  return JSON.parse(replacedStr);
};

// Merge common and pages translations
const zhCNTranslations = replaceToSSG({ ...zhCN, ...pagesZhCN });
const enUSTranslations = replaceToSSG({ ...enUS, ...pagesEnUS });

// Always use English as default language
const getInitialLanguage = () => {
  return 'en-US';
};

i18n
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      'zh-CN': {
        translation: zhCNTranslations
      },
      'en-US': {
        translation: enUSTranslations
      }
    },
    lng: getInitialLanguage(), // Default language
    fallbackLng: 'en-US', // Fallback language
    interpolation: {
      escapeValue: false // React already escapes by default
    }
  });

// 监听语言变化，保存到localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
  document.documentElement.lang = lng;
});

export default i18n;
